import { useEffect } from "react";
import { motion } from "framer-motion";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";
import TypeIt from "typeit";
import Android from "../img/android.png";
import CourseDetail8 from "../components/CourseDetail8";
import CourseDetail81 from "../components/CourseDetail81";
import Android_Cover from "../img/Android_Cover.png";
import undraw1 from "../img/undraw_android_jr64.svg";
import undraw2 from "../img/undraw_mobile_re_q4nk.svg";

const AndroidCourse = () => {
  useEffect(() => {
    // 獨立成新檔案後，startDelay 的時間可以縮短，不需要再等 Java 跑完
    new TypeIt("#element3", {
      strings: ["Android開發全攻略"],
      speed: 100,
      afterComplete: (instance) => {
        const el = document.querySelector("#element3");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();

    new TypeIt("#element4", {
      strings:
        "從基礎到進階：超過45小時的全面Android開發課程！十三種軟體設計模式、Kotlin語法、四個實作專案（繪圖軟體、重力五子棋遊戲、圖片搜尋App和圖書館系統），逐步開發App的基礎架構和進階實作，手把手帶你學習安卓應用程式開發！",
      speed: 15,
      startDelay: 1500,
      loop: false,
      afterComplete: (instance) => {
        const el = document.querySelector("#element4");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();
  }, []);

  return (
    <div>
      <motion.div
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        className="webdev"
        exit="exit"
      >
        <div className="img">
          <img src={Android_Cover} alt="" />
        </div>
        <div className="desc">
          <h1>
            <span id="element3"></span>
          </h1>
          <div className="content">
            <h3 id="element4"></h3>
          </div>
          <div>
            <p>
              課程價格: <span className="hide">新台幣$290</span>
            </p>
            <p>
              優惠代碼(點擊連結即可自動套用優惠碼):
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/android-dev-wilson/?couponCode=${process.env.REACT_APP_ANDROID_COUPON}`}
                rel="noreferrer"
              >
                <span>{process.env.REACT_APP_ANDROID_COUPON}</span>
              </a>
              (只到
              <span style={{ color: "red" }}>{process.env.REACT_APP_DATE}</span>
              之前有效)
            </p>
            <p>
              優惠碼課程連結:
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/android-dev-wilson/?couponCode=${process.env.REACT_APP_ANDROID_COUPON}`}
                rel="noreferrer"
              >
                <span className="hide">
                  https://www.udemy.com/course/android-dev-wilson/
                </span>
              </a>
            </p>
          </div>
        </div>
        <CourseDetail81 img={undraw1} />
        <CourseDetail8 img={undraw2} />
        <ScrollTop />
      </motion.div>
    </div>
  );
};

export default AndroidCourse;
